import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Ribbon from "@/components/site/Ribbon";
import About from "@/components/site/About";
import Classes from "@/components/site/Classes";
import Coaches from "@/components/site/Coaches";
import Schedule from "@/components/site/Schedule";
import Reviews from "@/components/site/Reviews";
import Gallery from "@/components/site/Gallery";
import Reels from "@/components/site/Reels";
import Footer from "@/components/site/Footer";
import BookPage from "@/components/site/BookPage";
import Contact from "@/components/site/Contact";

function Home() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <Ribbon />
        <About />
        <Classes />
        <Coaches />
        <Schedule />
        <Reviews />
        <Gallery />
        <Reels />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    // Expose the instance so Navbar/other components can drive smooth-scroll
    // through Lenis (native scrollIntoView fights Lenis and is unreliable on
    // mobile + fixed-header layouts).
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      if (window.__lenis === lenis) delete window.__lenis;
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/book" element={<BookPage />} />
      </Routes>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#161616",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#fff",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
